// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.4.1-2bW5h7N5TLEKpP3hb61d/mode=imports,min/optimized/keen-slider.js' // https://keen-slider.io/docs
class SocialCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    this.previewTimeouts = new Map()

    super.connectedCallback()

    this.carousel = this.initializeCarousel()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.videos) return

    this.pauseVideos()

    this.videos.forEach(slide => {
      this.listeners.add(
        slide,
        'mouseenter',
        this.previewVideo.bind(this, slide),
      )
      this.listeners.add(slide, 'mouseleave', this.pauseVideo.bind(this, slide))
    })
  }

  initializeCarousel () {
    if (!this.els?.slides?.exists || !this.slide.exists) return

    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: false,
      mode: 'snap',
      rubberband: false,
      slides: {
        origin: 'auto',
        perView: this.numberOfSlidesMobile,
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 600px)': {
          slides: {
            perView: this.numberOfSlidesTablet,
            spacing: 20,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            perView: this.numberOfSlidesDesktop,
            spacing: 20,
          },
        },
      },
    })
  }

  previewVideo (slide) {
    if (window.innerWidth <= 900) return

    const videos = this.getVideoElements(slide)
    if (videos.length === 0) return

    // Clear any existing timeout for this slide
    const existingTimeout = this.previewTimeouts.get(slide)
    if (existingTimeout) clearTimeout(existingTimeout)

    videos.forEach(video => {
      // Reset to start and play
      video.currentTime = 0
      video.muted = true
      video.play().catch(() => {})
      slide.classList.add('soc-Slide_Playing')
    })

    // Auto-pause after 2 seconds
    const timeout = setTimeout(() => {
      videos.forEach(video => {
        if (!video.paused) {
          video.pause()
          slide.classList.remove('soc-Slide_Playing')
        }
      })
    }, 2000)

    this.previewTimeouts.set(slide, timeout)
  }

  pauseVideo (slide) {
    const videos = this.getVideoElements(slide)
    if (videos.length === 0) return

    // Clear the preview timeout
    const timeout = this.previewTimeouts.get(slide)
    if (timeout) {
      clearTimeout(timeout)
      this.previewTimeouts.delete(slide)
    }

    // Pause and reset
    videos.forEach(video => {
      if (!video.paused) {
        video.pause()
      }
      video.currentTime = 0
    })
    slide.classList.remove('soc-Slide_Playing')
  }

  pauseVideos () {
    this.videos?.forEach(slide => this.pauseVideo(slide))
  }

  getVideoElements (slide) {
    const lazyVideos = slide.querySelectorAll('lazy-video')
    const videos = []

    lazyVideos.forEach(lazyVideo => {
      const video = lazyVideo.querySelector('video')
      if (video) videos.push(video)
    })

    return videos
  }

  get numberOfSlidesMobile () {
    return this.slides?.dataset.slidesMobile
  }

  get numberOfSlidesTablet () {
    return this.slides?.dataset.slidesTablet
  }

  get numberOfSlidesDesktop () {
    return this.slides?.dataset.slidesDesktop
  }

  get slides () {
    return this.els?.slides?.element
  }

  get slide () {
    return this.els?.slide
  }

  get videos () {
    return this.els?.videoSlide.elements
  }

  get desktopVideos () {
    return this.els?.desktopVideo
  }
}

if (!customElements.get('social-carousel')) {
  customElements.define('social-carousel', SocialCarousel)
}
